import { FC, cloneElement } from 'react'

import NiceModal from '@ebay/nice-modal-react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Callout, TextLink } from 'baby-design'
// eslint-disable-next-line import/no-extraneous-dependencies
import { SimpleShipping } from 'baby-design/icons'
import { CONSOLIDATED_SHIPPING_COPY } from 'src/constants'

import ConsolidatedShippingExplainerModal from '../ConsolidatedShippingExplainerModal'
import { ConsolidatedShippingCalloutProps } from './ConsolidatedShippingCallout.types'
import css from './ConsolidatedShippingCallout.styles.scss'

const LearnMoreCTA: FC<{ onClick: () => void }> = ({ onClick }) => (
  <TextLink
    underline
    innerContentClassName={css.ConsolidatedShippingCallout__link}
    size="md"
    onClick={onClick}
  >
    Learn more
  </TextLink>
)

const TextLinkCTA: FC<{
  textLink: ConsolidatedShippingCalloutProps['textLink']
}> = ({ textLink }) =>
  cloneElement(textLink, {
    innerContentClassName: css.ConsolidatedShippingCallout__link,
  })

const CTA: FC<
  Pick<ConsolidatedShippingCalloutProps, 'textLink' | 'learnMoreLink'> & {
    onClick: () => void
  }
> = ({ textLink, learnMoreLink, onClick }) => {
  if (textLink) {
    return <TextLinkCTA textLink={textLink} />
  }

  if (learnMoreLink !== false) {
    return <LearnMoreCTA onClick={onClick} />
  }

  return null
}

const ConsolidatedShippingCallout: FC<ConsolidatedShippingCalloutProps> = ({
  text,
  title,
  variant = 'single-line',
  textLink,
  learnMoreLink = true,
}) => {
  const onClick = async () => {
    await NiceModal.show(ConsolidatedShippingExplainerModal)
  }

  const cta = (
    <CTA learnMoreLink={learnMoreLink} textLink={textLink} onClick={onClick} />
  )

  const titleText = title || CONSOLIDATED_SHIPPING_COPY

  return (
    <Callout
      backgroundColor="green"
      cta={cta}
      icon={<SimpleShipping />}
      iconColor="green"
      text={text}
      title={titleText}
      variant={variant}
    />
  )
}

export default ConsolidatedShippingCallout
